export default "__VITE_ASSET__QNDBHvqy__"